import cx from 'classnames';
import { h } from 'preact';

function Ad() {
  const classes = cx('c-ad-flex_bg--gray preact__ad');

  return (
    <div class="plugin plugin--centered">
      <div class={classes}>
        <div class="c-ad-flex__inner">
          <p class="c-ad-flex__thanks">
            The Texas Tribune thanks its sponsors.
            <a href="https://mediakit.texastribune.org/">
              <strong>Become one</strong>
            </a>
            .
          </p>
          <div class="c-ad-flex__unit">
            <div class="dv-gpt-ad"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ad;